import { render, staticRenderFns } from "./WeightLossFlowTwo.vue?vue&type=template&id=71b31f6e&scoped=true"
import script from "./WeightLossFlowTwo.vue?vue&type=script&lang=js"
export * from "./WeightLossFlowTwo.vue?vue&type=script&lang=js"
import style0 from "./WeightLossFlowTwo.vue?vue&type=style&index=0&id=71b31f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b31f6e",
  null
  
)

export default component.exports